import {Exam} from '@/plugins/api'
/* eslint-disable no-unused-vars */
export default {
  namespaced: true,
  state: {
    examTime: null,
    formattedTime: '',
    formattedDate: '',
    nextExam: null,
    isPublishStandardRecordScore: true,
    isPublishStandardExamScore: true,
    standardRecordScore: 0,
    standardExamScore: 25.5
  },
  mutations: {
    SET_EXAM_TIME(state, time) {
      state.examTime = time
    },
    SET_FORMATTED_TIME(state, time) {
      state.formattedTime = time
    },
    SET_FORMATTED_DATE(state, date) {
      state.formattedDate = date
    },
    SET_NEXT_EXAM(state, exam) {
      state.nextExam = exam
    }
  },
  getters: {
    getExamTime: state => state.examTime,
    getFormattedTime: state => state.formattedTime,
    getFormattedDate: state => state.formattedDate,
    getNextExam: state => state.nextExam,
    getPublishScore: state => ({
      isPublishStandardRecordScore: state.isPublishStandardRecordScore,
      isPublishStandardExamScore: state.isPublishStandardExamScore,
      standardRecordScore: state.standardRecordScore,
      standardExamScore: state.standardExamScore
    })
  },
  actions: {
    async getExamInformation({commit}) {
      const examInformation = await Exam.getExamInformation()

      // Calculate exam time
      const now = new Date()
      const examTimes = []

      const studentExams = Array.isArray(examInformation.studentExams) ? examInformation.studentExams : []
      studentExams.forEach(exam => {
        const rooms = Array.isArray(exam.rooms) ? exam.rooms : []
        rooms.forEach(room => {
          const subjects = Array.isArray(room.subjects) ? room.subjects : []
          subjects.forEach(subject => {
            examTimes.push({
              time: new Date(subject.time),
              exam
            })
          })
        })
      })

      const futureTimes = examTimes.filter(({time}) => time > now).sort((a, b) => a.time - b.time)

      const nextExamData = futureTimes[0] || {time: new Date(), exam: null}
      // Format time and date
      // Xác định thời gian tập trung dựa trên cấp học
      let gatherTimeOffset = 45; // Mặc định là 45 phút cho cấp THCS
      if (nextExamData.exam && nextExamData.exam.grade === 'high') {
        gatherTimeOffset = 30; // 30 phút cho cấp THPT
      }
      const gatherTime = new Date(nextExamData.time.getTime() - gatherTimeOffset * 60 * 1000)
      const formattedTime = gatherTime.toLocaleTimeString('vi-VN', {
        hour: '2-digit',
        minute: '2-digit'
      })

      const formattedDate = nextExamData.time.toLocaleDateString('vi-VN', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })

      commit('SET_EXAM_TIME', nextExamData.time)
      commit('SET_FORMATTED_TIME', formattedTime)
      commit('SET_FORMATTED_DATE', formattedDate)
      commit('SET_NEXT_EXAM', nextExamData.exam)

      return examInformation
    },
    async fetchExams({commit}, options) {
      const exams = await Exam.fetch({...options, _sort: 'createdAt:desc'})
      return exams
    },
    async fetchExam({commit}, id) {
      const exam = await Exam.fetchOne(id)
      return exam
    },
    async createExam({commit}, data) {
      const newExam = await Exam.create(data)
      return newExam
    },
    async updateExam({commit}, {id, ...examData}) {
      const updatedExam = await Exam.update(id, {...examData})
      return updatedExam
    }
  }
}
/* eslint-disable no-unused-vars */
